import React, { useEffect, useRef, useState } from 'react';
import { useWindowSize } from 'react-use';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, useTheme } from '@mui/material';

import { SubmitButton, TopBorderPaper } from 'components';
import { ROUTES } from 'consts';
import { BuildingForm } from 'forms';
import { useAppDispatch, useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { updateLayout } from 'store/slices/layout.slice';

interface BuildingCreatePageProps {}

export const BuildingCreatePage: React.FC<BuildingCreatePageProps> = () => {
  const dispatch = useAppDispatch();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const theme = useTheme();
  const formRef = useRef<any>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'Create Building' }));
  }, []);

  const submitButtonLabel = width < theme.breakpoints.values.sm ? 'Create' : 'Create Building';

  return (
    <Box sx={{ width: '100%', maxWidth: theme.breakpoints.values.md, margin: 'auto', paddingX: 3, paddingY: 6 }}>
      <TopBorderPaper>
        <Box sx={{ width: '100%', maxWidth: theme.breakpoints.values.sm, margin: 'auto', padding: 3 }}>
          <Box sx={{ paddingY: 4 }}>
            <Typography variant="h5">Let’s set up your building</Typography>
          </Box>

          <BuildingForm
            ref={formRef}
            onSubmitting={(loading) => setLoading(!!loading)}
            next={() => navigate(`/${orgSlug}/${ROUTES.BUILDINGS}`)}
          />

          <SubmitButton
            loading={loading}
            label={submitButtonLabel}
            onClick={() => formRef.current.onSubmit()}
            sx={{ marginY: 4 }}
          />
        </Box>
      </TopBorderPaper>
    </Box>
  );
};
